import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_TOKEN_SET,
  USER_STATISTICS_DETAILS,
  USER_STORE_FIND,
  USER_STORE_NOT_FOUND,
  SIGNIN_USER,
  USER_LOGOUT,
  SHOW_SEKELETON_MENU,
  HIDE_SEKELETON_MENU,
  SET_SUBSCRIPTION,
  LOAD_MENU,
  STORE_INFO
} from '../../constants/ActionTypes'
import { message } from 'antd'
import * as ds from '../../Services/DataServices'
import axios from 'axios'
import * as storeState from '../store/index'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { RSA_NO_PADDING, SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS } from 'constants'
import ErrorList from 'antd/lib/form/ErrorList'
import { loadLoginLoader, loadUserSelectOutReg } from './CommonData'
import {
  loadCurrentSalesOrderData,
  loadOutletRegisters,
  loadSelectedOutletRegisters,
  loadSelectedStoreOutlets
} from './Sell'
import { loadPreventSellRunnerExecution } from './MainSale'
import { READ } from '../../constants/RightsAndPermissions'
import { setCommonConfigs, loadIsStoreExpired } from './CommonData'
import {
  BASE_URL,
  APP_STORE_WEB_URL,
  APP_BASE_LOCAL_URL
} from '../../Services/DataServices'
import { resolve } from 'dns'
import {
  checkExpiresSub,
  checkUserVerifyPage,
  isEmptyObject,
  loadInvAdjMovement
} from '.'
import { BUS_SITE_LOCAL_IP } from '../../constants/StoreSetting'
import { checkIsWeb, postDataToApp } from './MobAppFn'
import { POS_APP_TYPES, PostAppTypes } from '../../constants/MobAppConstants'
// import { truncate } from "fs/promises";

export const setInitUrl = url => {
  return {
    type: INIT_URL,
    payload: url
  }
}

// axios.defaults.baseURL = BASE_URL;
const messagAlert = message
//const dispatch=useDispatch();

messagAlert.config({
  duration: 3,
  top: 24,
  maxCount: 1
})

export const userLogOut = state => {
  return dispatch => {
    if (checkIsWeb().exist) {
      dispatch({
        type: USER_LOGOUT
      })
      localStorage.clear()
      window.location.href = '/signin'
    } else {
      postDataToApp(PostAppTypes.LOGOUT, true)
    }
  }
}
export const getSubscriptionPacakages = () => {
  return dispatch => {
    dispatch({ type: FETCH_START })
    const payloadInit = {
      packages: ''
    }
    axios
      .get(`${BASE_URL}store/GetSubscriptions`, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
          'X1Auth-SHA': localStorage.getItem('x1AUTH_SHA'),
          'X2Auth-SHB': localStorage.getItem('x1AUTH_SHB'),
          'Access-Control-Allow-Origin': BASE_URL,
          'Access-Control-Allow-Credentials': true
        }
      })
      .then(({ data }) => {
        if (data.data) {
          dispatch({ type: FETCH_SUCCESS })
          payloadInit.packages = data.data.packages
          dispatch({
            type: SET_SUBSCRIPTION,
            payload: JSON.stringify(payloadInit)
          })
        }
      })
      .catch(error => {
        dispatch({ type: FETCH_ERROR })
        console.log('Error:', error)
      })
  }
}

export const userSignUp = ({ email, password, name }) => {
  return dispatch => {
    dispatch({
      type: FETCH_START
    })
    axios
      .post('auth/register', {
        email: email,
        password: password,
        name: name
      })
      .then(({ data }) => {
        if (data.result) {
          localStorage.setItem('token', JSON.stringify(data.token.access_token))
          axios.defaults.headers.common['authorization'] =
            'Bearer ' + data.token.access_token
          dispatch({
            type: FETCH_SUCCESS
          })
          dispatch({
            type: USER_TOKEN_SET,
            payload: data.token.access_token
          })
          dispatch({
            type: USER_DATA,
            payload: data.user
          })
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Network Error'
          })
        }
      })
      .catch(function (error) {
        dispatch({
          type: FETCH_ERROR,
          payload: error.message
        })
        console.log('Error****:', error.message)
      })
  }
}

export const userStore = (store, form, history) => async dispatch => {
  return new Promise((resolve, reject) => {
    dispatch({
      type: FETCH_START
    })
    axios
      .post(`${BASE_URL}login/validateRegistration`, {
        storeURL: store.storeName
      })
      .then(res => {
        dispatch(loadLoginLoader(false))
        if (res.data.msgCode === 'URL_NOT_AVAILABLE' && res.data.data != null) {
          dispatch({ type: FETCH_SUCCESS })

          //localStorage.setItem("storeName", res.data.data.storeName);
          //localStorage.setItem("storeDataHash", res.data.data.storeDataHash);
          //localStorage.setItem("storeHash", res.data.data.storeHash);

          // let expires = new Date();
          // expires.setTime(expires.getTime() + (response.data.expires_in * 1000));

          //Cookies.set('storeInfo', 'value' ,{ storeName: res.data.data.storeName,storeHash:  res.data.data.storeHash});
          const payload = {
            value: true,
            storeNameLoad: res.data.data.storeName,
            storeHash: res.data.data.storeHash,
            reqNo: res.data.data.reqNo
          }
          //storeNamePage(res.data.data.storeName, res.data.data.storeHash);
          return dispatch({
            type: USER_STORE_FIND,
            payload: payload
          })
        } else {
          if (res.data.msgDescription != '') {
            messagAlert.error(res.data.msgDescription)
          }
          dispatch({ type: FETCH_ERROR })
          return dispatch({
            type: USER_STORE_NOT_FOUND,
            payload: {
              value: false,
              storeNameLoad: 'false'
            }
          })
        }
      })
      .catch(error => {
        dispatch(loadLoginLoader(false))
        dispatch({ type: FETCH_ERROR })
        message.error('Something went wrong')
        reject('error', error)
        throw { message: 'Something went wrong' }
      })
  })
}
export const userSignIn = (user, history, isSwitch) => async dispatch => {
  return new Promise((resolve, reject) => {
    dispatch({ type: FETCH_START })
    axios
      .post(
        `${BASE_URL}login/login`,
        {
          loginName: user.userName,
          userPassword: user.userPassword,
          StoreName: user.storeName,
          //StoreDataHash: user.storeDataHash,
          PageID: user.pageID ? `${user.pageID}` : ''
          // AppKey: 2
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-STORE-HASH': localStorage.getItem('storeHash')
              ? localStorage.getItem('storeHash').toString()
              : '',
            'X-STORE-NAME': localStorage.getItem('storeName')
              ? localStorage.getItem('storeName').toString()
              : '',
            //"X-DATA-HASH": localStorage.getItem("storeDataHash") ? localStorage.getItem("storeDataHash").toString() : "",
            'X-LANG': 1
          }
        }
      )
      .then(response => {
        if (user.pageID && user.pageID !== '') {
          const rights = response.data.data.rightsPermission
            ? response.data.data.rightsPermission.storeCommonConfigs.storeConfig
                .pageRiteAndPermission.rites
            : false
          if (rights && rights.length > 0) {
            dispatch(setCommonConfigs('', response.data.data.rightsPermission))
          } else {
            return resolve({
              msgDescription:
                'This person does not have permission on currently opened menu'
            })
          }
        }
        const outRegEnabled = user.isOutRegDisabled ? false : true

        dispatch({ type: FETCH_SUCCESS })
        if (response.data.msgCode == 'LOGIN_DONE') {
          dispatch({
            type: SIGNIN_USER,
            payload: {
              token: response.data.data.token,
              x1Auth_SHA: response.data.data.x1Auth_SHA,
              x1Auth_SHB: response.data.data.x1Auth_SHB,
              subscriptionExpiresOn: response.data.data.subscriptionExpiresOn,
              storeCommonConfigurations:
                response.data.data.storeCommonConfigurations,
              value: true
            }
          })
          localStorage.setItem('token', response.data.data.token)
          localStorage.setItem('x1AUTH_SHA', response.data.data.x1Auth_SHA)
          localStorage.setItem('x1AUTH_SHB', response.data.data.x1Auth_SHB)
          localStorage.setItem(
            'subscriptionExpiresOn',
            response.data.data.subscriptionExpiresOn
          )
          // localStorage.setItem(
          //   "storageCommonConfigurations",
          //   JSON.stringify(response.data.data.storeCommonConfigurations)
          // );
          if (response.data.data && response.data.data.profileImageURL) {
            localStorage.setItem(
              'profileImage',
              response.data.data.profileImageURL
            )
          }
          if (isEmptyObject(isSwitch)) {
            if (
              // outRegEnabled &&
              response.data.data &&
              response.data.data.userSelectedOutReg
            ) {
              let selectedData = response.data.data.userSelectedOutReg
              if (
                selectedData.selectedOutlet &&
                selectedData.selectedOutlet.id &&
                selectedData.selectedOutlet.outlet
              ) {
                let body = {
                  OutletID: selectedData.selectedOutlet.id
                }

                localStorage.setItem(
                  'selectedOut',
                  JSON.stringify(selectedData.selectedOutlet)
                )
                dispatch(loadOutletRegisters(body, true))
                // dispatch(loadSelectedStoreOutlets(selectedData.selectedOutlet))
              }
              if (
                selectedData.selectedRegister &&
                selectedData.selectedRegister.id &&
                selectedData.selectedRegister.register
              ) {
                localStorage.setItem(
                  'selectedReg',
                  JSON.stringify(selectedData.selectedRegister)
                )
                // dispatch(loadSelectedOutletRegisters(selectedData.selectedRegister))
              }
            }
          } else {
            if (isSwitch.outletID || isSwitch.registerID) {
              let postBody = {
                OutletID:
                  isSwitch && isSwitch.outletID ? isSwitch.outletID : '',
                RegisterID:
                  isSwitch && isSwitch.registerID ? isSwitch.registerID : ''
              }
              dispatch(loadUserSelectOutReg(postBody))
            }
          }

          login_redirect(dispatch, history, false, !isEmptyObject(isSwitch))
          dispatch(loadLoginLoader(false))
        } else {
          dispatch({
            type: SIGNIN_USER,
            payload: {
              value: false
            }
          })
          dispatch({ type: FETCH_ERROR })
          dispatch(loadLoginLoader(false))
          messagAlert.error(response.data.msgDescription, 3)
        }
        resolve(response.data)
      })
      .catch(error => {
        dispatch(loadLoginLoader(false))
        dispatch({ type: FETCH_ERROR })
        resolve(error)
        dispatch(loadLoginLoader(false))
        // reject(error);
      })
  })
}

export const getMenu = check => async dispatch => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${BASE_URL}store/getmenus`, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
          'X1Auth-SHA': localStorage.getItem('x1AUTH_SHA'),
          'X2Auth-SHB': localStorage.getItem('x1AUTH_SHB'),
          'X-LANG': localStorage.getItem('X-LANG'),
          'Access-Control-Allow-Origin': BASE_URL,
          'Access-Control-Allow-Credentials': true
        }
      })
      .then(({ data }) => {
        if (data.msgCode == 'GENERAL_SUCCESS') {
          localStorage.removeItem('menu')
          localStorage.setItem('menu', JSON.stringify(data.data))
          dispatch({ type: LOAD_MENU, payload: true })
          if (data && data.data && data.data.storeInfo) {
            const inv_types = data.data.storeInfo.invMovementTypes
            if (inv_types && inv_types.length > 0) {
              dispatch(loadInvAdjMovement(inv_types))
            }
            dispatch({ type: STORE_INFO, payload: data.data.storeInfo })
            if (data.data.storeInfo && data.data.storeInfo.isStoreExpired) {
              dispatch(loadIsStoreExpired(true))
              if (
                !window.location.pathname
                  .toLocaleLowerCase()
                  .includes('billingplans')
              ) {
                window.location = '/dashboard/billingplans'
              }
            } else {
              dispatch(loadIsStoreExpired(false))
            }
          }
        }
        resolve(data.data)
      })
      .catch(function (e) {
        dispatch({ type: LOAD_MENU, payload: true })
        resolve(e)
        if (!check) {
          if (!checkUserVerifyPage() && checkExpiresSub() > 0) {
            if (e.response && e.response.status === 401) {
              message.error('Token Expired! Redirecting to Login Page')
              setTimeout(() => {
                dispatch(userLogOut('store.getState()'))
              }, 3000)
            } else {
              // message.error('Something is wrong...')
            }
          }
        }
        // console.log("Error****:", error.message);
      })
  })
}

export const getUser = () => {
  return dispatch => {
    dispatch({
      type: FETCH_START
    })
    axios
      .post('auth/me')
      .then(({ data }) => {
        if (data.result) {
          dispatch({
            type: FETCH_SUCCESS
          })
          dispatch({
            type: USER_DATA,
            payload: data.user
          })
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: data.error
          })
        }
      })
      .catch(function (error) {
        dispatch({
          type: FETCH_ERROR,
          payload: error.message
        })
        console.log('Error****:', error.message)
      })
  }
}

export async function checkIfTokenExpired (dispatch, history) {
  dispatch(loadLoginLoader(true))
  const respMenu = await dispatch(getMenu(true))
  const check = await respMenu
  if (check && check.menus) login_redirect(dispatch, false, false)
  else clearAllAuth(history)
  dispatch(loadLoginLoader(false))
}

function clearAllAuth (history) {
  // localStorage.clear();
  // history.push("/signin");
}

export function login_redirect (dispatch, history, fromApp, isSiwtch) {
  let signInToken = localStorage.getItem('token')
  if (typeof signInToken != 'undefined' && signInToken !== null) {
    const switchPath = false // localStorage.getItem('switchRedirectURL')
    if (switchPath && switchPath != 'undefined' && switchPath != '') {
      // localStorage.removeItem('switchRedirectURL')
      if (history) {
        history.push('/Dashboard') //NOTE: this line is for re executing mainSell.js (it doesnt re excecuted earlier as the URL remains same and we are using history.push...! make sense)
        history.push(switchPath)
      } else window.location.href = switchPath
      //reloading sale in progress
      // const sale = localStorage.getItem("saleInProgress") ? JSON.parse(localStorage.getItem("saleInProgress")) : {};
      // if (sale && !isEmptyObject(sale)) {
      //   localStorage.removeItem("saleInProgress");
      //   dispatch(loadPreventSellRunnerExecution(false));
      //   dispatch(loadCurrentSalesOrderData(sale));
      // }
    } else {
      if (fromApp) {
        if (!isSiwtch) {
          if (fromApp == POS_APP_TYPES.RETAIL) {
            history.push('dashboard/sell/mainsale/webregister')
            // window.location.href = 'dashboard/sell/mainsale/webregister'
          } else if (fromApp == POS_APP_TYPES.REPORTING) {
            window.location.href = 'Dashboard/main'
          } else if (fromApp == POS_APP_TYPES.SCANNER) {
          }
        }
      } else {
        if (!isSiwtch) {
          window.location.href = '/Dashboard'
        }
      }
    }
  }
}

export function storeNamePage (storeName, storeHash) {
  if (storeName && storeHash) {
    //form.setFieldsValue({ storeName: storeName }); //, storeDataHash: storeDataHash
    //message.success("You already signed in to " + store);
    const baseURL = window.location.origin

    if (APP_BASE_LOCAL_URL != baseURL && BUS_SITE_LOCAL_IP != baseURL) {
      //window.location.href = APP_STORE_WEB_URL.replace('[domain]', store) + '/loginstore?signupStore=' + store+'&storeToken='+storeHash;//+'&storeKey='+storeDataHash;
      window.location.href =
        APP_STORE_WEB_URL.replace('[domain]', storeName) + '/loginstore' //+'&storeKey='+storeDataHash;
    } else {
      if (APP_BASE_LOCAL_URL == baseURL) {
        window.location.href = APP_BASE_LOCAL_URL + '/loginstore' //+'&storeKey='+storeDataHash;
      } else {
        window.location.href = baseURL + '/loginstore' //+'&storeKey='+storeDataHash;
      }

      //  history.push("/loginstore");
    }
  } else {
    localStorage.clear()
    // checkIfTokenExpired(dispatch, history);
  }
}
